import { RefSerializer } from "@tblabs/truffle";
import { Human } from "../../../Models/Human";
import { Order } from "../../../Models/Order";
import { RawHuman } from "../../../Models/RawHuman";
import { RawOrder } from "../../../Models/RawOrder";
import { StepType } from "../../../Steps/Step/StepType";
import { RefConverter } from "../RefConverter";
import { StepFactory } from "../../StepFactory";
import { OrderMeta } from "../../../Models/OrderMeta";


export class OrderConverter extends RefConverter<RawOrder, Order>
{
    constructor(private _stepFactory: StepFactory)
    {
        super();
    }

    protected ConvertFromRaw(raw: RawOrder): Order | null
    {
        const order = new Order();
        order.Id = this.GetString(raw.Id);

        order.Steps = this.GetCollection(raw.Steps, x => this._stepFactory.Create(x.Type as StepType, x.Data));

        const people = this.GetCollection<RawHuman, Human>(raw.People, x => new Human(x));
        order.People.Load(...people.Items);

        order.Meta = new OrderMeta(raw.Meta);
        // order.Log = new OrderLog(raw.Log);

        order.Notes.Public.value = this.GetString(raw.Notes?.Public);
        order.Notes.Private.value = this.GetString(raw.Notes?.Private);

        order.SelfSetup();

        return order;
    }

    protected ConvertToRaw(order: Order): RawOrder | null
    {
        return RefSerializer.Flatenize({
            Id: order.Id.toUpperCase(),
            Steps: order.Steps.Items.map(x => ({ Type: x.Type, Data: x.Data })),
            People: order.People.Items,
            Meta: order.Meta,
            Notes: {
                Public: order.Notes.Public.value,
                Private: order.Notes.Private.value
            }
        });
    }
}
